const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const isLocalHost = (hostname) =>
  ["localhost", "127.0.0.1", "::1"].includes(String(hostname || "").toLowerCase());

const getWindowBackendUrl = () => {
  if (typeof window === "undefined") return "";

  const { hostname, origin } = window.location;
  if (isLocalHost(hostname)) {
    return "http://localhost:7100/backend";
  }

  return `${trimTrailingSlash(origin)}/backend`;
};

export const getBackendBaseUrl = () => {
  const envUrl =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_BASE_URL;

  return trimTrailingSlash(envUrl || getWindowBackendUrl() || "https://dev.insightwin.com/backend");
};

export const getBackendOrigin = () => getBackendBaseUrl().replace(/\/backend$/, "");

export const getBackendServiceUrl = (servicePath = "") => {
  const service = String(servicePath || "").replace(/^\/+/, "");
  return service ? `${getBackendBaseUrl()}/${service}` : getBackendBaseUrl();
};

export default getBackendBaseUrl;
